import React, { Component } from 'react';
import { Link } from 'react-router-dom';
//import Modal from '../components/modal/modal';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import DeletePrompt from '../components/deletePrompt';

export const DefaultLayout = (Wrapped) => (props) => {
    return (
        <div>
            { /* props._menuOpen ? 
                <Menu {...props} />
            : 
            null*/
            }
            {
                props.loader ?
                    <div className="loader">
                        <div className="lds-ripple"><div></div><div></div></div>
                    </div>
                    : null
            }
            <Header {...props} />
            <Sidebar {...props} />

            <div className={props.subMenu ? 'sub-menu-active' : props.sidebar ? 'sidebar-active' : ''}>
                <Wrapped {...props} />
            </div>
            {
                props.deletePrompt ?
                    <DeletePrompt
                        {...props}
                    />
                    : null
            }

            {
                /* props._modalOpen ?
                 <Modal {...props} /> : null
                 */
            }
        </div>
    );
};

export default DefaultLayout;


// WEBPACK FOOTER //
// ./src/containers/defaultLayout.js